import { useState } from "react";
import type { TabDefinition } from "@bruntworkwear-apps/ui";
import type { ReconciliationResult } from "@/shared/api";

export type ReviewTab = "lines" | "orders" | "flags";

/**
 * Which review tab is showing.
 *
 * Opens on flags when there are any: the reviewer's first question is what
 * needs attention, not what went smoothly.
 */
export function useReviewTabs(result: ReconciliationResult) {
  const [active, setActive] = useState<ReviewTab>(result.flags.length > 0 ? "flags" : "orders");
  const [selectedPo, setSelectedPo] = useState<string | null>(null);

  const tabs: TabDefinition[] = [
    { id: "orders", label: "Purchase orders", badge: result.purchase_orders.length },
    { id: "lines", label: "Lines", badge: result.lines.length },
    { id: "flags", label: "Flags", badge: result.flags.length },
  ];

  return {
    tabs,
    active,
    setActive: (id: string) => setActive(id as ReviewTab),
    selectedPo,
    // Clicking the open order closes it, so the control is its own undo.
    togglePo: (po: string) => setSelectedPo((current) => (current === po ? null : po)),
    closePo: () => setSelectedPo(null),
  };
}
